// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"Payments_datepicker__3imSu","root":"Payments_root__1LQEz","paper":"Payments_paper__356T5"};